<template>
  <div class="receipt-content-container">
    <div class="receipt-header">
      <div class="receipt-header-info">
        <h6 class="receipt-sub-header">{{receipt.title}} {{receipt.series}}-{{receipt.number}}</h6>
        <h6
          v-if="receipt.cancelled"
          class="receipt-sub-header"
          style="color: #007bff"
        >Έχει βγει πιστωτικό</h6>
        <h6
          v-if="receipt.thesisOfReceipt && receipt.typeOfReceipt!='DISPATCH_NOTE'"
          class="receipt-sub-header"
        >{{getSpotOfReceipt(receipt)}}</h6>
        <h6
          v-if="receipt.waiterName!=null && receipt.waiterName.trim().length>0"
          class="receipt-sub-header"
        >Χρήστης: {{receipt.waiterName}}</h6>
        <!--Invoice info details-->
        <div v-if="receipt.invoiceInfo!=null">
          <h6 class="invoice-info">ΑΦΜ πελάτη: {{receipt.invoiceInfo.vat}}</h6>
          <h6 class="invoice-info">Επωνυμία: {{receipt.invoiceInfo.name}}</h6>
          <h6 class="invoice-info">Οδός: {{receipt.invoiceInfo.street}}</h6>
          <h6 class="invoice-info">Πόλη: {{receipt.invoiceInfo.city}}</h6>
          <h6 class="invoice-info">Τ.Κ.: {{receipt.invoiceInfo.postal_code}}</h6>

          <h6
            v-if=" receipt.invoiceInfo.comments!=null"
            class="invoice-info"
          >Παρατηρήσεις: {{receipt.invoiceInfo.comments}}</h6>

          <hr v-if="receipt.invoiceInfo.dispatchDate!=null" class="mb-2 mt-2" />

          <h6
            v-if="receipt.invoiceInfo.dispatchDate!=null"
            class="invoice-info mb-1 mt-1"
          >Ημ/νία αποστολής: {{getReversedDispatchDateTime(receipt.invoiceInfo.dispatchDate)}}</h6>
          <h6
            v-if="receipt.invoiceInfo.movePurpose!=null"
            class="invoice-info mb-1"
          >Σκοπός μεταφοράς: {{receipt.invoiceInfo.movePurpose}}</h6>
          <h6
            v-if="receipt.invoiceInfo.pickupAddressStreet!=null"
            class="invoice-info mb-1"
          >Τόπος φόρτωσης: {{receipt.invoiceInfo.pickupAddressStreet}}, {{receipt.invoiceInfo.pickupCity}}</h6>
          <h6
            v-if="receipt.invoiceInfo.deliveryAddressStreet!=null"
            class="invoice-info mb-2"
          >Τόπος προορισμού: {{receipt.invoiceInfo.deliveryAddressStreet}}, {{receipt.invoiceInfo.deliveryCity}}</h6>
        </div>

        <!--Payment type details-->
        <h6
          v-if="receipt.paymentType=='CASH' && receipt.typeOfReceipt!='DISPATCH_NOTE'"
          class="payment-type"
        >
          Τρ. πληρωμής: Μετρητά
          <font-awesome-icon style="margin-left: 2px; color: #198b4a" icon="money-bill" />
        </h6>
        <h6 v-if="receipt.paymentType=='CARD_TERMINAL'" class="payment-type">
          Τρ. πληρωμής: Κάρτα
          <font-awesome-icon style="margin-left: 2px; color: #17a2b8" icon="credit-card" />
        </h6>
        <h6 v-if="receipt.paymentType=='ON_CREDIT'" class="payment-type">
          Τρ. πληρωμής: Eπί πιστώσει
          <font-awesome-icon style="margin-left: 2px; color: #343a40" icon="history" />
        </h6>
        <h6 v-if="receipt.paymentType=='BANK_ACCOUNT'" class="payment-type">
          Τρ. πληρωμής: Λογ. Τράπεζας
          <font-awesome-icon style="margin-left: 2px; color: #6c757d" icon="hotel" />
        </h6>
        <h6 class="receipt-date">{{getDateForReceipt(receipt.dateOfReceipt)}}</h6>
      </div>

      <div class="receipt-buttons-container">
        <button
          v-if="!receipt.cancelled && receipt.typeOfReceipt !='RETURN' && receipt.typeOfReceipt !='DISPATCH_NOTE'"
          @click="cancelReceipt()"
          class="publish-return-rcpt-btn"
          style="background-color: #17a2b8; display: flex; align-items: center"
        >
          Πιστωτικό
          <clip-loader
            v-if="cancelingReceipt"
            :loading="cancelingReceipt"
            style="margin-left:4px; margin-top:5px"
            size="12px"
            color="#ffffff"
          />
          <font-awesome-icon v-else style="margin-left: 3px;" icon="backward" />
        </button>
        <span v-if="errorDuringCancel" class="error-msg">Κάτι πήγε λάθος</span>

        <button
          @click="goToOxygenView()"
          class="go-to-oxygen-btn"
          style="background-color: #0275d8; display: flex; align-items: center"
        >
          Oxygen
          <font-awesome-icon style="margin-left: 4px;" icon="eye" />
        </button>

        <button
          v-if="receipt.paymentType=='ON_CREDIT'"
          @click="sendPaymentToPos()"
          class="pay-to-pos-btn"
          style="background-color: #28a745;"
        >
          Πληρωμή σε
          <span style="font-size: 11px;">POS</span>
        </button>
        <button
          v-if="userCanReprintReceipt"
          @click="printReceipt()"
          class="print-receipt-again-button"
        >
          <clip-loader
            v-if="printingReceipt"
            :loading="printingReceipt"
            size="15px"
            color="#ffffff"
          />
          <font-awesome-icon id="print-receipt-icon" v-else icon="print" />
        </button>
      </div>
    </div>
    <div class="receipt-body">
      <div v-for="item in receipt.items" :key="item.id" class="item-in-receipt">
        <span class="item-receipt-quantity">{{item.quantity}}</span>
        <span class="item-receipt-name">{{item.itemName}}</span>
        <span class="item-receipt-price">{{item.totalPrice.toFixed(2)}}</span>
      </div>
    </div>
    <div class="receipt-footer">
      <span class="receipt-total-amount">Σύνολο: {{calculateTotalOfReceipt(receipt.items)}}€</span>
    </div>
  </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import StoreApi from "../api/stores";
export default {
  name: "FinalReceipt",
  components: { ClipLoader },
  data() {
    return {
      printingReceipt: false,
      errorDuringCancel: false,
      cancelingReceipt: false
    };
  },
  props: ["receipt", "restaurantId", "adminAccounts", "authToken", "jwt", "userCanReprintReceipt"],
  methods: {
    getDateForReceipt(dateIso) {
      let date = new Date(dateIso);

      let day = date.getDate();
      day = day < 10 ? `0${day}` : day;
      let month = date.getMonth() + 1;
      month = month < 10 ? `0${month}` : month;

      let hours = date.getHours();
      hours = hours < 10 ? `0${hours}` : hours;
      let minutes = date.getMinutes();
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      let dateString = `${day}-${month}-${date.getFullYear()} ${hours}:${minutes}`

      return dateString;
    },

    goToOxygenView() {
      let oxygenUrl = `https://www.iview.gr/${this.receipt.oxygenIcode}`
      window.open(oxygenUrl, "_blank");
    },

    getReversedDispatchDateTime(dispatchDateTime) {
      let dateOfDispatch = dispatchDateTime.split(" ")[0];
      let reversedDispatchDate = this.reverseDate(dateOfDispatch);
      let timeOfDispatch = dispatchDateTime.split(" ")[1].slice(0, -3);

      return `${reversedDispatchDate} ${timeOfDispatch}`;
    },

    reverseDate(dateStr) {
      return dateStr.split('-').reverse().join('-');
    },

    calculateTotalOfReceipt(items) {
      let total = 0;
      items.forEach(item => total = total + item.totalPrice);
      return total.toFixed(2);
    },

    async printReceipt() {
      this.printingReceipt = true;
      this.$emit("print-final-receipt", this.receipt.id);
      setTimeout(() => {
        this.printingReceipt = false;
      }, 1600);
    },

    getSpotOfReceipt(receipt) {
      let servingPointName;
      switch (receipt.thesisOfReceipt) {
        case "HOTEL_ROOM":
          servingPointName = "Δωμάτιο";
          break;
        case "TABLE":
          servingPointName = "Τραπέζι";
          break;
        case "TABLE_AT_HOTEL":
          servingPointName = "Τραπέζι";
          break;
        case "BEACH_CHAIR":
          servingPointName = "Ομπρέλα";
          break;
        case "UMBRELLA_AT_HOTEL":
          servingPointName = "Ομπρέλα";
          break;
        case "DELIVERY_TABLE":
          servingPointName = "Σημείο";
          break;
        default:
          servingPointName = "Σημείο";
      }

      let spotOfReceipt = receipt.tableNumber.startsWith("Τραπέζι") || receipt.tableNumber.startsWith("Δωμάτιο") || receipt.tableNumber.startsWith("Ομπρέλα") ? receipt.tableNumber : `${servingPointName}: ${receipt.tableNumber}`;
      return spotOfReceipt;
    },

    sendPaymentToPos() {
      this.$emit("send-payment-to-pos", this.receipt);
    },

    cancelReceipt() {
      if (!this.cancelingReceipt) {
        this.$confirm({
          message: "Είστε σίγουρος για την ακύρωση του παραστατικού και την έκδοση πιστωτικού;",
          button: {
            yes: 'Ναι',
            no: 'Ακύρωση'
          },
          callback: async confirm => {
            if (confirm) {
              this.cancelingReceipt = true;
              this.errorDuringCancel = false;

              let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.restaurantId);
              let userId = adminAcountOfUserForCurrentRestaurant != null && adminAcountOfUserForCurrentRestaurant != undefined ? adminAcountOfUserForCurrentRestaurant.userId : null;

              let response = await StoreApi.cancelReceipt(this.restaurantId, this.receipt.id, userId, this.authToken, this.jwt);
              if (response.error) {
                this.errorDuringCancel = true;
                this.cancelingReceipt = false;
              } else {
                this.$emit("fetch-final-receipts-and-orders", response);
                this.cancelingReceipt = false;
              }
            }
          }
        });
      }

    }
  },
  mounted() {

  }
};
</script>

<style scoped>
.receipt-content-container {
  display: flex;
  flex-direction: column;
  margin: 4px 8px 4px 8px;
  padding-bottom: 4px;
  border: 2px solid rgb(92, 184, 92, 0.9);
  border-radius: 8px;
  margin-bottom: 16px;
}

.receipt-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding-left: 6px;
  padding-top: 4px;
  border-bottom: 1px solid rgb(94, 94, 94);
  background-color: rgb(92, 184, 92, 0.2);
  border-radius: 8px 8px 0px 0px;
}

.receipt-header-info {
  display: flex;
  flex-direction: column;
}

.receipt-sub-header {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0px !important;
  color: rgb(29, 29, 29);
}

.error-msg {
  margin-bottom: 2px;
  font-size: 13px;
  font-weight: 700;
  color: #dc3545;
}

.payment-type {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
  color: rgb(29, 29, 29);
}

.invoice-info {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 0px;
  color: rgb(29, 29, 29);
}

.receipt-date {
  font-size: 13px;
  font-weight: 500;
  color: rgb(58, 58, 58);
  margin-bottom: 4px;
}

.receipt-buttons-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.cancel-receipt-button {
  color: white;
  background-color: #ee1228;
  font-size: 13px;
  margin-right: 10px;
}

.print-receipt-again-button {
  padding: 4px 8px 4px 8px;
  border-radius: 6px;
  cursor: pointer;

  color: white;
  background-color: #198b4a;
  font-size: 15px;
  margin-right: 4px;
}

.go-to-oxygen-btn,
.publish-return-rcpt-btn,
.pay-to-pos-btn {
  padding: 4px 5px 4px 5px;
  border-radius: 6px;
  cursor: pointer;

  color: white;
  font-size: 12px;
  margin-right: 4px;
  margin-bottom: 6px;
}

.receipt-body {
  display: flex;
  flex-direction: column;
}

.item-in-receipt {
  padding-left: 6px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: baseline;
  padding-bottom: 5px;
  padding-top: 5px;
  border-top: 1px solid rgb(186, 186, 186);
}

.item-receipt-quantity {
  font-size: 17px;
  font-weight: 700;
  margin-right: 5px;
  color: #198b4a;
}

.item-receipt-name {
  font-size: 16px;
  font-weight: 600;
  margin-right: 5px;
  color: rgb(47, 47, 47);
}

.item-receipt-price {
  font-size: 15px;
  font-weight: 500;
  color: rgb(47, 47, 47);
}

.receipt-footer {
  display: flex;
  flex-direction: row;
  border-top: 1px solid rgb(126, 126, 126);
  padding-top: 7px;
  padding-bottom: 4px;
}

.receipt-total-amount {
  font-size: 18px;
  font-weight: 700;
  padding-left: 8px;
  color: rgb(79, 79, 79);
}

.checkbox-for-final {
  width: 28px;
  margin-right: 10px;
  border-radius: 30px;
}

.mb-1 {
  margin-bottom: 4px;
}

.mt-1 {
  margin-top: 4px;
}

.mb-2 {
  margin-bottom: 8px;
}

.mt-2 {
  margin-top: 8px;
}
</style>